import { render, staticRenderFns } from "./User-square.vue?vue&type=template&id=79cfe270"
import script from "./User-square.vue?vue&type=script&lang=js"
export * from "./User-square.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports